"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSplitUsedOrActiveDiscount = exports.isDiscountExpired = exports.isExpenseDiscountable = exports.isDiscountActionPossibleForExpense = exports.getUsedOrActiveExpenseDiscount = exports.getActiveExpenseDiscount = exports.calculateSplitDiscounts = exports.calculateSplitDiscountFromExpenseDiscount = exports.calculateExpenseDiscount = exports.calculateDiscountInformation = exports.calculateReductionDinero = exports.mapExpenseAmountToDinero = exports.mapExpenseAmountToNumber = void 0;
const moment_1 = __importDefault(require("moment"));
const expensePaymentOption_enum_1 = require("../models/expense/expensePaymentOption.enum");
const expenseStatus_enum_1 = require("../models/expense/expenseStatus.enum");
const common_1 = require("./common");
const mapExpenseAmountToNumber = (amount) => ({
    net: (0, common_1.toAmount)(amount.net),
    tax: (0, common_1.toAmount)(amount.tax),
    gross: (0, common_1.toAmount)(amount.gross),
});
exports.mapExpenseAmountToNumber = mapExpenseAmountToNumber;
const mapExpenseAmountToDinero = (amount) => ({
    net: (0, common_1.toDinero)(amount.net),
    tax: (0, common_1.toDinero)(amount.tax),
    gross: (0, common_1.toDinero)(amount.gross),
});
exports.mapExpenseAmountToDinero = mapExpenseAmountToDinero;
const calculateReductionDinero = (amount, percentage) => amount.percentage(percentage);
exports.calculateReductionDinero = calculateReductionDinero;
const calculateDiscountInformation = (amount, discountPercentage) => {
    const amountInDinero = (0, exports.mapExpenseAmountToDinero)(amount);
    const reductionInDinero = {
        gross: (0, exports.calculateReductionDinero)(amountInDinero.gross, discountPercentage),
        tax: (0, exports.calculateReductionDinero)(amountInDinero.tax, discountPercentage),
        net: (0, exports.calculateReductionDinero)(amountInDinero.net, discountPercentage),
    };
    const reducedInDinero = {
        gross: amountInDinero.gross.subtract(reductionInDinero.gross),
        tax: amountInDinero.tax.subtract(reductionInDinero.tax),
        net: amountInDinero.net.subtract(reductionInDinero.net),
    };
    return {
        reduction: (0, exports.mapExpenseAmountToNumber)(reductionInDinero),
        reduced: (0, exports.mapExpenseAmountToNumber)(reducedInDinero),
    };
};
exports.calculateDiscountInformation = calculateDiscountInformation;
const calculateExpenseDiscount = (expense, discountRule) => {
    const discountInformation = (0, exports.calculateDiscountInformation)({
        gross: expense.totalGrossPrice,
        net: expense.totalNetPrice,
        tax: expense.totalTaxPrice,
    }, discountRule.percentage);
    const dueDate = (0, moment_1.default)(expense.invoiceDate).add(discountRule.period, "days").toDate();
    return {
        percentage: discountRule.percentage,
        period: discountRule.period,
        dueDate,
        reducedAmount: discountInformation.reduced,
    };
};
exports.calculateExpenseDiscount = calculateExpenseDiscount;
const calculateSplitDiscountFromExpenseDiscount = (split, expenseDiscount) => {
    const splitAmountInformation = {
        gross: split.grossPrice,
        net: split.netPrice,
        tax: split.taxPrice,
    };
    const { reduced } = (0, exports.calculateDiscountInformation)(splitAmountInformation, expenseDiscount.percentage);
    return Object.assign(Object.assign({}, expenseDiscount), { reducedAmount: reduced });
};
exports.calculateSplitDiscountFromExpenseDiscount = calculateSplitDiscountFromExpenseDiscount;
const calculateSplitDiscounts = (split, expenseDiscounts) => expenseDiscounts.map((expenseDiscount) => (0, exports.calculateSplitDiscountFromExpenseDiscount)(split, expenseDiscount));
exports.calculateSplitDiscounts = calculateSplitDiscounts;
const getActiveExpenseDiscount = (expense) => { var _a; return (_a = expense.discounts) === null || _a === void 0 ? void 0 : _a[0]; };
exports.getActiveExpenseDiscount = getActiveExpenseDiscount;
const getUsedOrActiveExpenseDiscount = (expense) => { var _a, _b; return (_b = (_a = expense === null || expense === void 0 ? void 0 : expense.payment) === null || _a === void 0 ? void 0 : _a.usedDiscount) !== null && _b !== void 0 ? _b : (0, exports.getActiveExpenseDiscount)(expense); };
exports.getUsedOrActiveExpenseDiscount = getUsedOrActiveExpenseDiscount;
/**
 * To determine if an expense can be discounted, and on the right state for user to attach the discount.
 * An expense can be only manually attached a discount if it's in the REVIEWED status.
 */
const isDiscountActionPossibleForExpense = (expense) => (0, exports.isExpenseDiscountable)(expense) && expense.status === expenseStatus_enum_1.ExpenseStatusEnum.REVIEWED;
exports.isDiscountActionPossibleForExpense = isDiscountActionPossibleForExpense;
/**
 * To determine if an expense can be given a discount
 */
const isExpenseDiscountable = (expense) => {
    const isNotRefund = !(expense.totalNetPrice < 0 || expense.totalGrossPrice < 0);
    return !expense.isSubscription() && !expense.isReimbursement && expense.paymentOption !== expensePaymentOption_enum_1.ExpensePaymentOptionEnum.SMART_CARD && isNotRefund;
};
exports.isExpenseDiscountable = isExpenseDiscountable;
const isDiscountExpired = (expense) => { var _a; return (0, moment_1.default)().isAfter((0, moment_1.default)((_a = (0, exports.getActiveExpenseDiscount)(expense)) === null || _a === void 0 ? void 0 : _a.dueDate), "day"); };
exports.isDiscountExpired = isDiscountExpired;
const getSplitUsedOrActiveDiscount = (split) => { var _a; return (_a = split.usedDiscount) !== null && _a !== void 0 ? _a : (0, exports.getActiveExpenseDiscount)(split); };
exports.getSplitUsedOrActiveDiscount = getSplitUsedOrActiveDiscount;
